import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  ATT,
  Astound,
  BrightspeedV2,
  BuckeyeBroadband,
  CenturyLink,
  CincinnatiBell,
  Comcast,
  Cox,
  Earthlink,
  Frontier,
  Mediacom,
  Optimum,
  QuantumFiber,
  Spectrum,
  TDS,
  Verizon,
  Windstream,
  WOW,
} from 'config/providers';
import { XfinityTheme } from 'config/themes';

export const XfinitySpecial: SingleProviderConfig = {
  name: 'XfinitySpecial',
  micrositeCode: 'Comcast',
  mainProvider: Comcast,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'xfinityspecial.com',
  homepage: 'https://xfinityspecial.com',
  title: 'Xfinity Authorized Dealer',
  fallbackPhoneNumber: '866-417-5505',
  fallbackLeadModePhoneNumber: '866-495-3522',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: XfinityTheme,
  needsDcSession: true,
  source: 'Xfinity',
  noOffersRetry: 2,
  commercialHomepage: 'https://comcastbusinessspecial.com',
  getCrossSellAction: getDefaultCrossSellAction,
  crossSellProviders: [
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Astound,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    BrightspeedV2,
    QuantumFiber,
    CenturyLink,
    Frontier,
    Windstream,
    CincinnatiBell,
    Verizon,
    Earthlink,
  ],
  movingAppBuyflowUrls: {
    development: 'http://localhost:3000/guest/tvi/buy',
    staging: 'https://staging-cart.xfinityspecial.com/guest/tvi/buy',
    qa: 'https://staging-cart.xfinityspecial.com/guest/tvi/buy',
    production: 'https://cart.xfinityspecial.com/guest/tvi/buy',
  },
  getCheckoutType: asyncEligible,
};
